import Place from './Place';
import { UserIsAuthenticated, siteTitle } from '../';

import EditReview from './EditReview';
const PlaceRoutes = {
    place: {
        path: '/place/:id',
        label: 'Place',
        title: `${siteTitle} - Place`,
        component: UserIsAuthenticated(Place),
        childRoutes: [{
            path: 'review',
            component: Place,
            title: 'editing',
            label: 'Reviewing'
        }]
    }
};

export { PlaceRoutes, Place };



// WEBPACK FOOTER //
// ./src/app/containers/Place/index.ts